"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.KnockListItem = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _KnockListItem = require("./KnockListItem.styled");
var _KnockItems = require("../KnockItems");
var _KnockTypes = require("../../../constants/KnockTypes");
var KnockListItem = exports.KnockListItem = function KnockListItem(_ref) {
  var knock = _ref.knock,
    onApprove = _ref.onApprove,
    onDeny = _ref.onDeny,
    sources = _ref.sources,
    allSources = _ref.allSources,
    maxCamerasExceeded = _ref.maxCamerasExceeded,
    onAVClicked = _ref.onAVClicked,
    onAssignKnockToSource = _ref.onAssignKnockToSource,
    isDisabled = _ref.isDisabled;
  var KnockItem = knockTypeComponents[knock.type];
  return /*#__PURE__*/_react["default"].createElement(_KnockListItem.KnockListItemWrapper, null, /*#__PURE__*/_react["default"].createElement(KnockItem, (0, _extends2["default"])({}, knock, {
    onApprove: onApprove,
    onDeny: onDeny,
    onAVClicked: onAVClicked,
    sources: sources,
    allSources: allSources,
    maxCamerasExceeded: maxCamerasExceeded,
    onAssignKnockToSource: onAssignKnockToSource,
    isDisabled: isDisabled
  })));
};
var knockTypeComponents = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _KnockTypes.PRESENTER, _KnockItems.PresenterKnockItem), _KnockTypes.SCREENSHARE, _KnockItems.ScreenShareKnockItem);
KnockListItem.propTypes = {
  knock: _propTypes["default"].shape({
    _id: _propTypes["default"].string,
    name: _propTypes["default"].string,
    type: _propTypes["default"].string,
    socketId: _propTypes["default"].string,
    isMicrophoneOn: _propTypes["default"].bool,
    isCameraOn: _propTypes["default"].bool
  }),
  onApprove: _propTypes["default"].func.isRequired,
  onDeny: _propTypes["default"].func.isRequired,
  sources: _propTypes["default"].array,
  allSources: _propTypes["default"].array,
  maxCamerasExceeded: _propTypes["default"].bool,
  onAVClicked: _propTypes["default"].func,
  onAssignKnockToSource: _propTypes["default"].func,
  isDisabled: _propTypes["default"].bool
};
var _default = exports["default"] = KnockListItem;